document.addEventListener("DOMContentLoaded", function() {
  var productsPerPage = document.getElementById("products-per-page");
  if (productsPerPage) {
    productsPerPage.addEventListener("change", function() {
      var viewParam = this.value;
      var currentUrl = window.location.href;
      
      // Check if the URL already contains parameters
      if (currentUrl.indexOf("?") !== -1) {
        // URL contains parameters
        var params = currentUrl.split("?")[1].split("&");
        var newParams = [];
        var found = false;

        for (var i = 0; i < params.length; i++) {
          var param = params[i].split("=");
          if (param[0] === "view") {
            newParams.push("view=" + viewParam);
            found = true;
          } else {
            newParams.push(params[i]);
          }
        }

        if (!found) {
          newParams.push("view=" + viewParam);
        }

        window.location.href = currentUrl.split("?")[0] + "?" + newParams.join("&");
      } else {
        // URL does not contain parameters, so append view parameter with ?
        window.location.href = currentUrl + "?view=" + viewParam;
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var languageList = document.getElementById('FooterLanguageList');
  var currentLanguageLink = languageList.querySelector('.disclosure__link--active');
  var currentLanguageListItem = currentLanguageLink.parentElement;
  
  // Hide the current language list item
  currentLanguageListItem.style.display = 'none';
});

document.addEventListener('DOMContentLoaded', function() {
    var switcherContainer = document.querySelector('.tl-switcher-container.top-right.tl-custom-position');
    var headerTopMenu = document.querySelector('.header-wrapper .header-top-menu');
    
    if (switcherContainer && headerTopMenu) {
        headerTopMenu.appendChild(switcherContainer);
    }
});